// src/pages/search/SearchResultPage.js
import React, { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { db } from "../../shared/libs/firebaseConfig";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import { Spinner } from "react-bootstrap";

import { BsClock, BsSearch } from "react-icons/bs";
import openai_icon from "../../assets/openai_icon.png";
import gemini_icon from "../../assets/gemini_icon.png";
import n8n_icon from "../../assets/n8n_icon.png";
import midjourney from "../../assets/midjourney_icon.png";
import perplexity from "../../assets/perplexity_icon.png";

// 1) brandKey -> icon
const BRAND_ICON_MAP = {
  openai: openai_icon,
  gemini: gemini_icon,
  n8n: n8n_icon,
  midjourney: midjourney,
  perplexity: perplexity,
  
 /*  googlesheets: Logo_Encraft_01,
  org: Logo_Encraft_02, */
};

// 2) slug -> brandKey
const SLUG_TO_BRAND_KEY = {
  chatgpt: "openai",
  openai: "openai",
  gemini: "gemini",
  n8n: "n8n",
  midjourney: "midjourney",
  perplexity: "perplexity",
  /* googlesheets: "Logo_Encraft_01",
  org: "Logo_Encraft_02", */
};

// 3) brandKey -> คำค้นที่จะส่งไปหน้า search
//   จะใช้คำเดียวกับ brandKey ก็ได้ หรือจะกำหนดเองแบบนี้ก็ได้
const BRAND_SEARCH_TERM = {
  openai: "chatgpt",   // ถ้าอยากให้ค้นด้วยคำว่า chatgpt
  gemini: "gemini",
  n8n: "n8n",
  midjourney: "midjourney",
  perplexity: "perplexity",
 /*  googlesheets: "Logo_Encraft_01",
  org: "Logo_Encraft_02", */
};

const getSearchTermForBrand = (brandKey) =>
  BRAND_SEARCH_TERM[brandKey] || brandKey;

const ArticleCard = ({ article }) => {


const navigate = useNavigate();
    // ดึง tagSlugs -> แปลงเป็น brandKey -> unique
    const aiBrandKeys = Array.from(
        new Set(
        (article.tagSlugs || [])
            .map((slug) => slug.toLowerCase())
            .map((slug) => SLUG_TO_BRAND_KEY[slug])  // แปลงเป็น brandKey
            .filter(Boolean)                         // ตัดตัวที่ map ไม่ได้ทิ้ง
        )
    );

  
    const handleClickBrand = (e, brandKey) => {
        e.preventDefault();      // กันไม่ให้ลิงก์การ์ดทำงาน
        e.stopPropagation();     // กัน bubbling ไป Link ด้านนอก
        const term = getSearchTermForBrand(brandKey);
        navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    const handleClickLevel = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = article.level?.toLowerCase() ?? "";
        if (term) navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    const handleClickCategory = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = (article.category || "").toLowerCase();
        if (term) navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    // 👇 ปุ่ม +N → ไปค้นคำว่า "ai tools"
    const handleClickMore = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = "ai tools";   // อยากเปลี่ยนคำค้นก็แก้ตรงนี้ได้เลย
        navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    // ดึง tagSlugs -> brandKey -> unique
    const allBrandKeys = Array.from(
        new Set(
            (article.tagSlugs || [])
            .map((slug) => slug.toLowerCase())
            .map((slug) => SLUG_TO_BRAND_KEY[slug])
            .filter(Boolean)
        )
    );

    // แบรนด์ที่จะแสดงเป็นไอคอนจริง ๆ (สูงสุด 3)
    const firstBrandKeys = allBrandKeys.slice(0, 3);

    // จำนวนแบรนด์ที่เหลือเกินจาก 3
    const extraCount = allBrandKeys.length - firstBrandKeys.length;


  const authorName =
    typeof article.author === "object"
      ? article.author.displayName ?? "-"
      : article.author ?? "-";

  const categoryName =
  typeof article.category === "object" && article.category?.name
    ? article.category.name
    : (typeof article.category === "string" ? article.category : "-");

const subCategoryName =
  typeof article.subCategory === "object" && article.subCategory?.name
    ? article.subCategory.name
    : (typeof article.subCategory === "string" ? article.subCategory : "-");


  const coverSrc =
    article.cover ||
    article.cover?.src ||
    (Array.isArray(article.contentBlocks)
      ? article.contentBlocks.find((b) => b.type === "image")?.src
      : "") ||
    "https://placehold.co/800x450/png";

  const updated = article.updatedAt?.toDate
    ? article.updatedAt.toDate()
    : article.updatedAt || null;

  const articleLink = `/articles/${article.slug || article.id}`;

  return (
    <Link to={articleLink} className="text-decoration-none text-reset">
      <div className="card article-card shadow-sm h-100">
        <div className="image-wrapper">
          <img src={coverSrc} className="card-img-top" alt={article.title || ""} />
        </div>

        <div className="card-body">
          <p className="card-meta">
            {updated ? new Date(updated).toLocaleDateString() : "-"} &nbsp;|&nbsp; {authorName}
          </p>

          <h5 className="articlename">{article.title || "-"}</h5>

          <div className="level-section">
            <span
                className="level-text"
              /*   role="button"
                style={{ cursor: "pointer" }}
                onClick={handleClickLevel} */
            >
                {article.level || ""}
            </span>
            {(firstBrandKeys.length > 0 || extraCount > 0) && (
                <div className="level-icons">
                    {firstBrandKeys.map((brandKey) => (
                        <img
                        key={brandKey}
                        src={BRAND_ICON_MAP[brandKey]}
                        alt={brandKey}
                        className="level-icon"
                        role="button"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => handleClickBrand(e, brandKey)}
                        />
                    ))}

                    {extraCount > 0 && (
                        <span
                        className="level-icon-more"
                        role="button"
                        style={{ cursor: "pointer" }}
                        onClick={handleClickMore}
                        >
                        +{extraCount}
                        </span>
                    )}
                </div>
            )}
          </div>

          <div className="card-footer-section">
            <div className="left">
              {article.views != null && (
                <span className="text-secondary">
                  <span className="badge-content-type">
                    {article.readTime != null
                      ? `${article.readTime} min read`
                      : (article.contentType || "article")}
                  </span>{" "}
                  • {Number(article.views).toLocaleString()} views
                </span>
              )}
            </div>
            <div className="right">
                <span
                    className="badge-content-type"
              /*       role="button"
                    style={{ cursor: "pointer" }}
                    onClick={handleClickCategory} */
                >
                    {categoryName}
                </span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default function SearchResultPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const qParam = searchParams.get("q") || "";

  const [queryText, setQueryText] = useState(qParam);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setQueryText(qParam);
  }, [qParam]);

  useEffect(() => {
    const term = qParam.trim().toLowerCase();
    if (!term) {
      setItems([]);
      return;
    }

    const run = async () => {
      setLoading(true);
      try {
        const ref = collection(db, "articles");
        const qBase = query(
          ref,
          where("status", "==", "published"),
          where("publicStatus", "==", true),
          orderBy("updatedAt", "desc"),
          limit(100)
        );
        const snap = await getDocs(qBase);
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

        const filtered = rows.filter((x) => {
          const t = term;

          const title = (x.title || "").toLowerCase();
          const slug = (x.slug || "").toLowerCase();
          const tagsD = Array.isArray(x.tagsDisplay)
            ? x.tagsDisplay.map((s) => s.toLowerCase())
            : [];
          const tagsS = Array.isArray(x.tagSlugs)
            ? x.tagSlugs.map((s) => s.toLowerCase())
            : [];

          // เพิ่มฟิลด์ที่ค้นหา: ผู้เขียน, หมวดหมู่, หมวดหมู่รอง
          const authorName = (x.author?.displayName || "").toLowerCase();
          const categoryName = (x.category?.name || "").toLowerCase();
          const subCategoryName = (x.subCategory?.name || "").toLowerCase();
          // 👇 เพิ่มส่วนนี้: รองรับการค้นหาด้วย level
          const level = (x.level || x.levelDisplay || "").toLowerCase();

          return (
            title.includes(t) ||
            slug.includes(t) ||
            tagsD.some((tg) => tg.includes(t)) ||
            tagsS.some((tg) => tg.includes(t)) ||
            authorName.includes(t) ||
            categoryName.includes(t) ||
            subCategoryName.includes(t) ||
            level.includes(t)
          );
        });

        setItems(filtered);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [qParam]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const term = queryText.trim();
    if (!term) return;
    setSearchParams({ q: term });
  };

  const total = items.length;

  return (
    <div className="container py-4">
      <form className="mb-3" onSubmit={handleSubmit}>
        <div className="header-search-box" style={{ maxWidth: 480 }}>
          <span className="header-search-icon"><BsSearch /></span>
          <input
            type="search"
            className="form-control header-search-input"
            placeholder="ค้นหาบทความใน Encraft"
            value={queryText}
            onChange={(e) => setQueryText(e.target.value)}
            enterKeyHint="search"   // ⭐ ปุ่ม Return → Search
          />
        </div>
      </form>

      {qParam ? (
        <div className="mb-3">
          <h4 className="m-0">
            ผลลัพธ์สำหรับ{" "}
            <span style={{ fontWeight: 600 }}>"{qParam}"</span>
          </h4>
          <div className="small text-muted">พบ {total} บทความ</div>
        </div>
      ) : (
        <div className="text-muted mb-3">
          พิมพ์คำค้นหาในช่องด้านบนเพื่อค้นหาบทความ
        </div>
      )}

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center my-4"
          style={{ minHeight: "120px" }}   // ให้มีพื้นที่นิดนึง
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">กำลังค้นหา…</span>
          </Spinner>
        </div>
      ) : !qParam ? null : total === 0 ? (
        <div className="text-muted">ไม่พบบทความที่ตรงกับคำค้นหา</div>
      ) : (
        <div className="row g-3 mt-2">
          {items.map((a) => (
            <div key={a.id} className="col-12 col-sm-6 col-lg-4">
              <ArticleCard article={a} />
            </div>
          ))}
        </div>
      )}

    </div>
  );
}

